import ApiClient from "@common/api/ApiClient";

/**
 * Class representing the authentication functionality for Guardian Authorisation API
 *
 * Note: Compliance components use this API instead of Guardian Mobile API for authorisation
 *
 * Extends the ApiClient to handle API requests
 *
 * @extends ApiClient
 */
class AuthenticationClient extends ApiClient {
  /**
   * Create a AuthenticationClient.
   * Initializes the API client with the "Authentication" route and sets the API URL key.
   */
  constructor() {
    super("Authentication");
    this.setApiUrlKey("auth_api_url");
  }

  SignIn = async (email, password, claims) => {
    return await this.post("SignIn", {
      id: email,
      password,
      claims,
    });
  };

  SwitchTenant = async (operator) => {
    return await this.post("SwitchTenant", { name: `${operator}` });
  };

  RefreshToken = async (refreshToken) =>
    await this.post("RefreshToken", { refreshToken });
}

const client = new AuthenticationClient();

export default client;
